// Module
var code = "<script>let $ctrl</script> <molecule-form-edit> <molecule-panel-error error-type=\"general\" error-box-type=\"fixed\"></molecule-panel-error> <organ-edit-panel-nextcloud-upgrade nextcloud=\"$ctrl.nextcloud\"></organ-edit-panel-nextcloud-upgrade> </molecule-form-edit> ";
// Exports
module.exports = code;